const MIN_TRIP_ID_PREFIX_LENGTH = 4;

export function normalizeTripLookupId(tripId) {
  return String(tripId || "").trim();
}

export function canUseTripIdPrefix(tripId) {
  return normalizeTripLookupId(tripId).length >= MIN_TRIP_ID_PREFIX_LENGTH;
}

export function normalizeGtfsStartDate(startDate) {
  if (typeof startDate !== "string" || !/^\d{8}$/.test(startDate)) {
    return null;
  }

  const year = Number(startDate.slice(0, 4));
  const month = Number(startDate.slice(4, 6));
  const day = Number(startDate.slice(6, 8));
  const parsed = new Date(Date.UTC(year, month - 1, day));

  return parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month - 1 &&
    parsed.getUTCDate() === day
    ? startDate
    : null;
}

// GTFS permits service-day times beyond midnight (for example 25:15:00).
// Keep this as text: converting it to a database time or JavaScript Date would
// discard its service-day meaning.
export function normalizeGtfsStartTime(startTime) {
  const normalized = String(startTime || "").trim();
  return /^\d{1,2}:\d{2}:\d{2}$/.test(normalized) ? normalized : null;
}

export function getRealtimeTripOccurrenceDescriptor({ tripId, startDate, startTime }) {
  const normalizedTripId = normalizeTripLookupId(tripId);
  const normalizedStartDate = normalizeGtfsStartDate(startDate);
  const normalizedStartTime = normalizeGtfsStartTime(startTime);

  if (!normalizedTripId) return null;

  return {
    tripId: normalizedTripId,
    startDate: normalizedStartDate,
    startTime: normalizedStartTime,
  };
}

export function getLiveTripOccurrenceKey({ tripId, startDate }) {
  const normalizedTripId = normalizeTripLookupId(tripId);
  const normalizedStartDate = normalizeGtfsStartDate(startDate);

  if (!normalizedTripId || !normalizedStartDate) {
    return null;
  }

  return `${normalizedTripId}::${normalizedStartDate}`;
}

// This is intentionally separate from getLiveTripOccurrenceKey(), whose
// two-part format is an existing public lookup contract. New persistence code
// should only use this three-part key after preserving the upstream entity.
export function getRealtimeTripOccurrenceKey({ tripId, startDate, startTime }) {
  const descriptor = getRealtimeTripOccurrenceDescriptor({
    tripId,
    startDate,
    startTime,
  });

  if (!descriptor?.startDate || !descriptor?.startTime) return null;

  return `${descriptor.tripId}::${descriptor.startDate}::${descriptor.startTime}`;
}
